import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { Trash2 } from 'react-feather';

/**
 * Render rows untuk tipe: sentence_arrangement
 * Support:
 * - Sequential interactive: hanya input "Nilai (Kunci)" (answer-only)
 * - Non-sequential: input Label + input Nilai/Jawaban (seperti existing)
 */
export default function SentenceArrangementRows(props) {
  const {
    data,
    answers,
    stateChoiceFromRedux,
    handleChangeChoice,
    handleChangeAnswer,
    handleRemoveOption,
    handleChangeSequentialAnswerOnly,
  } = props;

  const isSequential =
    data.is_interactive == 1 && data.interactive_type === 'sequential';

  return (
    <>
      {answers.map((option, index) => (
        <Row key={index}>
          {/* ✅ Sequential: 1 input saja, value dari ANSWER saja */}
          {isSequential ? (
            <Col className="col-11">
              <FormGroup className="mb-3">
                <Label
                  for={`validationSequential-${index}`}
                  style={{ fontWeight: 'bold' }}
                >
                  {'Nilai (Kunci)'}:{index > 0 && (
                    <Trash2 onClick={() => handleRemoveOption(index)} color="red" />
                  )}
                </Label>

                <Input
                  className="form-control"
                  id={`validationSequential-${index}`}
                  type="textarea"
                  name="sequential_answer"
                  placeholder="Tuliskan nilai/kunci (urutan benar). Nanti choice akan diacak dari answer saat simpan."
                  required=""
                  value={option || ''}
                  onChange={(e) =>
                    handleChangeSequentialAnswerOnly(index, e.target.value)
                  }
                />
              </FormGroup>
            </Col>
          ) : (
            <>
              {/* ✅ Default sentence_arrangement (non-sequential): tetap seperti semula (Label terpisah) */}
              <Col className="col-8">
                <FormGroup className="mb-3">
                  <Label
                    for={`validationChoice-${index}`}
                    style={{ fontWeight: 'bold' }}
                  >
                    {data.is_interactive == 1 ? 'Label' : 'Pilihan Jawaban'}:
                  </Label>

                  <Input
                    className="form-control"
                    id={`validationChoice-${index}`}
                    type="textarea"
                    name="choice"
                    placeholder={
                      data.is_interactive == 1
                        ? 'Tuliskan label'
                        : 'Tuliskan pilihan jawaban'
                    }
                    required=""
                    value={stateChoiceFromRedux[index]}
                    onChange={(e) => handleChangeChoice(index, e.target.value)}
                  />
                </FormGroup>
              </Col>

              {/* ✅ Jawaban/Nilai */}
              <Col className="col-4">
                <FormGroup className="mb-3">
                  <Label for="validationAnswer" style={{ fontWeight: 'bold' }}>
                    {data.is_interactive == 1 ? 'Nilai' : 'Jawaban'}:{' '}
                    {index > 0 && data?.interactive_type != 'clickable' && (
                      <Trash2 onClick={() => handleRemoveOption(index)} color="red" />
                    )}
                  </Label>

                  <Input
                    className="form-control"
                    id="validationAnswer"
                    type="text"
                    name="answer"
                    placeholder={
                      data.is_interactive == 1 ? 'Tuliskan nilai' : 'Tuliskan jawaban'
                    }
                    required=""
                    value={option || ''}
                    onChange={(e) => handleChangeAnswer(e, index, 'answer')}
                  />
                </FormGroup>
              </Col>
            </>
          )}
        </Row>
      ))}
    </>
  );
}